import { globals } from "@/globals";
import * as signals from "@/signals";
import { SearchEngineInfo } from "@/types";
import { t } from "i18next";

export function getPresetSearchEngines(
	region: string | null = signals.dynamicInfo.value.region || null,
): SearchEngineInfo[] {
	const isInChina = !region || region === "CN";
	const isNotInChina = !region || region !== "CN";

	const searchEngines = [
		{
			id: "preset-baidu",
			name: t("baidu"),
			url: "https://www.baidu.com/s?ie=utf-8&word=%s",
			when: true,
		},
		{
			id: "preset-bing",
			name: t("bing"),
			url:
				"https://" +
				(globals.isChinaTimeZone ? "cn" : "www") +
				".bing.com/search?form=QBLH&q=%s",
			when: true,
		},
		{
			id: "preset-google",
			isBlockedInChina: true,
			name: t("google"),
			url: "https://www.google.com/search?q=%s",
			when: true,
		},
		{
			id: "preset-yandex",
			name: "Yandex",
			url: "https://yandex.com/search/?text=%s",
			when: true,
		},
		{
			id: "preset-duckduckgo",
			isBlockedInChina: true,
			name: "DuckDuckGo",
			url: "https://duckduckgo.com/?q=%s",
			when: isNotInChina,
		},
		{
			id: "preset-sogou",
			name: t("sogou"),
			url: "https://www.sogou.com/web?query=%s",
			when: isInChina,
		},
		{
			id: "preset-360search",
			name: t("360Search"),
			url: "https://www.so.com/s?q=%s",
			when: isInChina,
		},
	];
	return searchEngines.filter((engine) => engine.when);
}
